"use strict";

import store from "../store/store";

const isValidIdentifer = (number, args) => {
  const validate = (number, args) => {
    if (
      [
        store.state.constants.IDENTIFIERS.CUIT,
        store.state.constants.IDENTIFIERS.CUIL
      ].indexOf(args[0]) > -1
    ) {
      // # validaciones minimas
      if (number.length != 13 || number[2] != "-" || number[11] != "-") {
        return false;
      }

      const base = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

      number = number.split("-").join(""); // remuevo las barras

      // calculo el digito verificador:
      let aux = 0;
      for (var i = 0; i < 10; i++) {
        aux += parseInt(number[i]) * base[i];
      }

      aux = 11 - (aux - parseInt(aux / 11) * 11);

      if (aux == 11) {
        aux = 0;
      }

      if (aux == 10) {
        aux = 9;
      }

      return aux == parseInt(number[10]);
    } else {
      return /\d{8}/.test(number);
    }
  };

  const result = validate(number, args);
  return { valid: result };
};

export default { isValidIdentifer };
